<div class="skeleton-loader">
    <!-- Right Section (Transaction List) -->
    <div class="skeleton-right">
      <!-- Tabs -->
      <div class="skeleton-tabs">
        <div class="skeleton-tab"></div>
        <div class="skeleton-tab"></div>
        <div class="skeleton-tab"></div>
      </div>
      <!-- Search Bar -->
      <div class="skeleton-search"></div>
      <!-- Card Placeholder -->
      <div class="skeleton-card"></div>
      <div class="skeleton-card"></div>
      <div class="skeleton-card"></div>
      <div class="skeleton-card"></div>
      <div class="skeleton-card"></div>
      <div class="skeleton-card"></div>
      <div class="skeleton-card"></div>
    </div>
  
    <!-- Left Section (Vertical Dates) -->
    <div class="skeleton-left">
      <div class="skeleton-date-half"></div>
      <div class="skeleton-date-half"></div>
      <div class="skeleton-date"></div>
      <div class="skeleton-date"></div>
      <div class="skeleton-date"></div>
    </div>
  </div>
  